module.exports = __webpack_public_path__ + "img/6ef21b4.png";